import { chain, size, sortBy } from 'underscore';

export const AgeRanges = {
  EighteenToTwentyFour: _TL_('18-24'),
  TwentyFiveToThirtyFour: _TL_('25-34'),
  ThirtyFiveToFourtyNine: _TL_('35-49'),
  FiftyToSixtyFour: _TL_('50-64'),
  SixtyFiveAndAbove: _TL_('65+'),
  Unknown: _TL_('Unknown'),
};

const sortAgeRanges = ageRanges => sortBy(ageRanges, ageRange => AgeRanges[ageRange]);

export const formatAgeRange = (ageRange, i18n) => (AgeRanges[ageRange] ? i18n.getString(AgeRanges[ageRange]) : ageRange);

export const formatAgeRanges = (ageRanges, i18n) => {
  if (size(ageRanges) === size(AgeRanges)) {
    return `{{dataTag}}${i18n.getString(_TL_('All ages'))}{{/dataTag}}`;
  }

  return chain(sortAgeRanges(ageRanges))
    .map(ageRange => `{{dataTag}}${formatAgeRange(ageRange, i18n)}{{/dataTag}}`)
    .join(i18n.getString(_TL_(', ')))
    .value();
};
